import React, {useState, useEffect} from 'react'
import {
  Route,
  Switch,
  BrowserRouter as Router
} from 'react-router-dom'
import axios from 'axios'
import moment from 'moment'
import Clock from 'react-live-clock'
import {Helmet} from "react-helmet"
import { Icon, Label, Popup } from 'semantic-ui-react'
import {WindowURLAdmin,WindowLocationAdmin,WindowReload} from '../config/settings'
import Alertmessage from '../config/alert'

import AdministratorComponent from './pages/administrator/list'
import SalesRepComponent from './pages/salesrep/list'
import TradingBuyComponent from './pages/tradingbuy/list'
import TradingSellComponent from './pages/tradingsell/list'
import FundingRecordComponent from './pages/fundingrecord/list'
import FundingTransferComponent from './pages/fundingtransfer/list'

import AccountComponent from './pages/account/list'
import AccountEditComponent from './pages/account/edit'
import AccountApprovalComponent from './pages/account/approval'

import Logo from '../../assets/images/logo.png'

export default function AppAdmin(props) {

  const [alert,setalert] = useState(true);
  const [Alertcontent,setAlertcontent] = useState({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait..."}});
  function Alertclose(){setalert(false);}
  function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
  function Alertdelete(data){
    if(data.delete==true){
      //console.log(data.id);
    }
  }

  function AddCustomClassBody(){
    document.body.classList.add("admin");
  }
  const [active, setactive] = useState('');
  function ActiveClass(){
    let path = window.location.pathname;
    var url=path.split('/');
    setactive(url[3]);
  }


  const [datenow, setdatenow] = useState(moment(new Date()).format('MMMM, DD, YYYY'));

  const [user, setuser] = useState('Guest');
  function LoginAccount(){
    let formData = new FormData();
    formData.append('type','adminuser');
    axios.post('/admin/login/http.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj==0){WindowLocationAdmin('/login');return false;}
        setuser(obj);
        setTimeout(function() {setalert(false);},2000);
    })
    .catch(function (error){
      setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
      setTimeout(function() {setalert(false);},2000);
    });
  }

  function LogoutAccount(){

    setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

    let formData = new FormData();
    formData.append('type','logout');
    axios.post('/admin/login/http.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj=='success'){
          setTimeout(function() {WindowLocationAdmin('/login');},2000);
          return false;
        }
        setTimeout(function() {WindowReload();},2000);
    })
    .catch(function (error){
      setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
      setTimeout(function() {setalert(false);},2000);
    });
  }

  useEffect(()=>{
    AddCustomClassBody();
    ActiveClass();
    LoginAccount();
  },[]);

	return (
    <React.Fragment>

      <Helmet>
          <title>Prime Capital Markets - Admin Dashboard</title>
      </Helmet>

      {alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}

       <div className="app-header-wrapper">
			 		<div className="app-container">
						<div className="app-logo-wrapper">
							 <div><img src="https://primecapitalmarkets.net/assets/images/logo.png"/></div>
							 <div>
                  <p><Clock date={new Date()} format={'dddd, MMMM DD, YYYY'} /> | <Clock format="h:mm:ss A" interval={1000} ticking={true} /></p>
                  <p><span><i className="uil-user"></i>Hi, {user}</span> | <span onClick={()=>LogoutAccount()}>Logout</span></p>
               </div>
						</div>
					</div>
			 </div>

			 <div className="app-menu-wrapper">
			 		<div className="app-container">
						<ul className="navmenu">
							 <li className={active=='account'?'active':''}><a href={WindowURLAdmin('/account/list')}><i className="uil-users-alt"></i>Account List </a></li>
							 <li className={active=='tradingbuy'?'active':''}><a href={WindowURLAdmin('/tradingbuy')}><i className="uil-cart"></i>Trading Record-Buy</a></li>
							 <li className={active=='tradingsell'?'active':''}><a href={WindowURLAdmin('/tradingsell')}><i className="uil-cart"></i>Trading Record-Sell</a></li>
							 <li className={active=='funding-record'?'active':''}><a href={WindowURLAdmin('/funding-record')}><i className="uil-bag-alt"></i>Funding Record</a></li>
               <li className={active=='funding-transfer'?'active':''}><a href={WindowURLAdmin('/funding-transfer')}><i className="uil-package"></i>Funding Transfer</a></li>
							 <li className={active=='salesrep'?'active':''}><a href={WindowURLAdmin('/salesrep')}><i className="uil-user-square"></i>Sales Rep</a></li>
							 <li className={active=='users'?'active':''}><a href={WindowURLAdmin('/users')}><i className="uil-user-check"></i>Admin</a></li>
						</ul>
					</div>
			 </div>

			 <div className="app-content">
          <div className="app-container">
    				 <Router>
    					 <Switch>
    						 <Route exact path={WindowURLAdmin('/')}  component={AdministratorComponent}/>


                 <Route exact path={WindowURLAdmin('/tradingbuy')}  component={TradingBuyComponent}/>
     						 <Route exact path={WindowURLAdmin('/tradingbuy/:id')}  component={TradingBuyComponent}/>

                 <Route exact path={WindowURLAdmin('/tradingsell')}  component={TradingSellComponent}/>
     						 <Route exact path={WindowURLAdmin('/tradingsell/:id')}  component={TradingSellComponent}/>

                 <Route exact path={WindowURLAdmin('/funding-record')}  component={FundingRecordComponent}/>
     						 <Route exact path={WindowURLAdmin('/funding-record/:id')}  component={FundingRecordComponent}/>

                 <Route exact path={WindowURLAdmin('/funding-transfer')}  component={FundingTransferComponent}/>
     						 <Route exact path={WindowURLAdmin('/funding-transfer/:id')}  component={FundingTransferComponent}/>

                 <Route exact path={WindowURLAdmin('/salesrep')}  component={SalesRepComponent}/>
    						 <Route exact path={WindowURLAdmin('/salesrep/:id')}  component={SalesRepComponent}/>


                 <Route exact path={WindowURLAdmin('/account/list')}  component={AccountComponent}/>
    						 <Route exact path={WindowURLAdmin('/account/edit/:id')}  component={AccountEditComponent}/>
                 <Route exact path={WindowURLAdmin('/account/approval/:id')}  component={AccountApprovalComponent}/>


    						 <Route exact path={WindowURLAdmin('/users')}  component={AdministratorComponent}/>
    						 <Route exact path={WindowURLAdmin('/users/:id')}  component={AdministratorComponent}/>

    					 </Switch>
    				 </Router>
             <div className="dashboard-footer">
                <p>Copyright © <Clock date={new Date()} format={'YYYY'} />  Gold Grup Limited</p>
             </div>
          </div>
			 </div>

    </React.Fragment>
	)
}
